/**
 * Returns structure with a bonus period information fields.
 *
 * @param {object} period
 * @return {{label, count, unit}|null}
 */
export default (period) => {
    const intervalBonus = period?.interval_bonus;
    if (!!intervalBonus) {
        return {
            unit: period?.interval_bonus_unit,
            count: intervalBonus,
            label: `${intervalBonus} ${period?.interval_bonus_unit}${intervalBonus > 1 ? 's' : ''}`
        };

    }
    return null;
}
